import { DocumentCard, DocumentCardImage, ImageFit } from "@fluentui/react";
import { baseUrlUser } from "../../../constants/url.constant";
import { MyTooltip } from "../../common/views/MyTooltip";
import { Utils } from "../../common/views/Utils";
import { emptyFunc } from "../../home/models/OtherTypes";
import { PictureModel, FileType, FileCategory } from "../models/PictureModel";

export class PictureUtils {
    public static getProductImageUrl(picture?: PictureModel) {
        return picture && !Utils.isNullOrEmpty(picture.imageUrl) ?
            baseUrlUser + picture.imageUrl : "";
    }

    public static createMediaElement(fileType: FileType, url: string, size: any): JSX.Element {
        let element = <></>;

        if (fileType === FileType.video) {
            element = <>
                <video
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                    controls
                >
                    <source src={url} type="video/mp4" />
                </video>
            </>;
        } else if (fileType === FileType.others) {
            element = <a href={url} target="_blank">pdf</a>;
        } else {
            if (Utils.isNull(size)) {
                size = Utils.pictureFileSizes["Mobile"];
            }

            element = <>
                <DocumentCardImage
                    imageFit={ImageFit.centerCover}
                    className="product-picture image-radius"
                    imageSrc={url}
                    height={size.height}
                />
            </>;
        }

        return element;
    }

    public static createImageElement2(
        type: FileType,
        url: string,
        category: FileCategory,
        size: any,
        onClick: emptyFunc
    ): JSX.Element {
        if (!size && !Utils.isNull(category)) {
            size = Utils.pictureFileSizes[FileCategory[category].toString()];
        }

        if (Utils.isNullOrEmpty(url)) return <></>;

        return <>
            <DocumentCard
                onClick={onClick}
                className="picture-wrapper pb-10"
                styles={{ root: { maxWidth: "100%" } }}
                style={{ width: "100%", minWidth: "100%" }}
            >
                {this.createMediaElement(type, url, size)}
            </DocumentCard>
        </>;
    }

    public static getMiniPicture(
        type: FileType,
        url: string,
        text: string,
        onClick: emptyFunc,
        width = 55
    ): JSX.Element {
        if (type === FileType.video) {
            url = "/dist/vendor/video.png";
        } else if (type === FileType.others) {
            url = "/dist/vendor/file.png";
        }

        if (Utils.isValidUrl(baseUrlUser + url)) {
            url = baseUrlUser + url;
        }

        const element = <DocumentCardImage
            width={width}
            height={width}
            imageFit={ImageFit.centerCover}
            imageSrc={url}
            styles={{ centeredIcon: { zIndex: 100 } }}
        />;

        return <>
            <DocumentCard
                onClick={onClick}
                className="cursor"
                style={{ width: width, minWidth: width }}
            >
                {!Utils.isNullOrEmpty(text) && <MyTooltip element={element} text={text} />}
                {Utils.isNullOrEmpty(text) && element}
            </DocumentCard>
        </>;
    }

    public static getLargePicture(type: FileType, url: string, onClick: emptyFunc): JSX.Element {
        if (Utils.isNullOrEmpty(url)) return <></>;

        return <>
            <DocumentCard
                onClick={onClick}
                className="picture-wrapper"
                styles={{
                    root: {
                        maxWidth: "100%",
                        height: "300px",
                        textAlign: "center"
                    }
                }}
            >
                {this.getMedia(type, url, "300px")}
            </DocumentCard>
        </>;
    }

    public static getMedia(fileType: FileType, url: string, maxHeight: string = "auto"): JSX.Element {
        if (Utils.isValidUrl(baseUrlUser + url)) {
            url = baseUrlUser + url;
        }

        let element = <></>;

        if (fileType === FileType.video) {
            element = <>
                <video
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                    controls
                >
                    <source src={url} type="video/mp4" />
                </video>
            </>;
        } else if (fileType === FileType.others) {
            element = <a href={url} target="_blank">pdf</a>;
        } else {
            element = <>
                <img
                    src={url}
                    alt=""
                    style={{
                        width: "auto",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: maxHeight
                    }}
                />
            </>;
        }

        return element;
    }
}